import React, { useState } from 'react';
import {Form, Button, Card, Container, Alert, Row, Col,} from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import {SERVER_BASE_URL} from "../Constants";

const CreateCompetition = () => {
    const [competition_name, setCompetitionName] = useState("");
    const [description, setDescription] = useState("");
    const [start_date, setStartDate] = useState("");
    const [end_date, setEndDate] = useState("");
    const [participation_type, setParticipationType] = useState("");

    const [errorMessage, setErrorMessage] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token =  Cookies.get("token");

            const response = await axios.post(SERVER_BASE_URL + 'api/competitions/create', {
                competition_name,
                description,
                start_date,
                end_date,
                participation_type
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
                },
            });

            console.log(response);

            // Handle successful response
            if (response.status === 200) {
                setErrorMessage("");
                // Redirect to the dashboard
                navigate('/competitions');
            } else {
                setErrorMessage(response.data || 'Login failed. Please try again.');
            }
        } catch (err) {
            // Handle API errors
            setErrorMessage(err.response.data || 'An error occurred during login.');
        }

    };

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Card style={{ width: "30rem" }} className="p-4 shadow">
                {errorMessage && (
                    <Alert variant="danger" onClose={() => setErrorMessage("")} dismissible>
                        {errorMessage}
                    </Alert>
                )}
                <Card.Body>
                    <h2 className="text-center mb-4">Create Competition</h2>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label column="md">Competition Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="competition_name"
                                value={competition_name}
                                onChange={(e) => setCompetitionName(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label column="md">Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group as={Row} controlId="participation_type" className="mb-3">
                            <Form.Label sm="3" column="sm">Participation Type:</Form.Label>

                            <Col sm="3">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Individuals"
                                    name="workoutVariation"
                                    value="individual"
                                    checked={participation_type === "individual"}
                                    onChange={(e) => setParticipationType(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Pairs"
                                    name="workoutVariation"
                                    value="pair"
                                    checked={participation_type === "pair"}
                                    onChange={(e) => setParticipationType(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Teams"
                                    name="workoutVariation"
                                    value="team"
                                    checked={participation_type === "team"}
                                    onChange={(e) => setParticipationType(e.target.value)}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label column="md">Start Date</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                name="start_date"
                                value={start_date}
                                onChange={(e) => setStartDate(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label column="md">End Date</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                name="end_date"
                                value={end_date}
                                onChange={(e) => setEndDate(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Button type="submit" variant="primary" className="w-100">Create Competition</Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default CreateCompetition;
